import { render, staticRenderFns } from "./DevsHowItWorks.vue?vue&type=template&id=9fd01d38&scoped=true&"
import script from "./DevsHowItWorks.vue?vue&type=script&lang=js&"
export * from "./DevsHowItWorks.vue?vue&type=script&lang=js&"
import style0 from "./DevsHowItWorks.vue?vue&type=style&index=0&id=9fd01d38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd01d38",
  null
  
)

export default component.exports